import React from "react";

import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { ProductsProvider } from "./context/ProductsContext";
import { AlertProvider } from "./context/AlertContext";
import { LocationProvider } from "./context/LocationContext";
import { AppSettingsProvider } from "./context/AppSettingsContext";
import AppShell from "./components/AppShell/AppShell";

function App() {
  return (
    <AuthProvider>
      <LocationProvider>
        <ProductsProvider>
          <AlertProvider>
            <CartProvider>
              <AppSettingsProvider>
                <AppShell />
              </AppSettingsProvider>
            </CartProvider>
          </AlertProvider>
        </ProductsProvider>
      </LocationProvider>
    </AuthProvider>
  );
}

export default App;
